import { render, staticRenderFns } from "./FormSelfPickUp.pug?vue&type=template&id=62590775&lang=pug&"
import script from "./FormSelfPickUp.vue?vue&type=script&lang=js&"
export * from "./FormSelfPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports